<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: laikt
 * @Date: 2020-11-09 10:06:38
 * @LastEditors: laikt
 * @LastEditTime: 2020-12-02 20:44:40
-->
<template>
  <div class="video-live">
    <section class="videos-wrap">
      <template v-if="formatVideo.length">
        <ul class="video-dom-wrap">
          <template v-for="(item, index) in formatVideo">
            <li v-if="item.realVideo" :key="item.cameraId" :class="videoCls">
              <div class="real-monit">
                <div class="left-head">
                  <div class="route-info">
                    <p
                      :class="[
                        item.monitStatus === 0 ? 'route-info-title' : ''
                      ]"
                      :title="item.cameraName"
                    >
                      {{ item.cameraName }}
                    </p>
                    <p
                      :id="[monitStatusClass[item.monitStatus]]"
                      v-if="item.monitStatus !== 0"
                    >
                      {{ monitStatus[item.monitStatus] }}
                    </p>
                  </div>
                </div>
                <div
                  class="real-message"
                  v-if="item.pointList && item.pointList.length"
                >
                  <ul class="scrollbar" ref="scrollbar">
                    <li
                      v-for="poin in item.pointList"
                      :key="poin.pointId"
                      :class="[
                        !isShow
                          ? 'rotate-90-transition rotate-90'
                          : 'rotate-90-transition',
                        monitStatusClass[poin.monitStatus]
                      ]"
                    >
                      <span class="list-message">{{ poin.pointName }}：</span>
                      <span class="list-value">
                        {{ poin.temp === -999 ? "暂无数据" : poin.temp + "℃" }}
                      </span>
                      <span
                        v-if="
                          poin.highOrLow === 1 &&
                            (poin.monitStatus === 3 || poin.monitStatus === 2)
                        "
                      >
                        <i
                          class="e6-icon-arrow_up"
                          v-for="num of poin.alarmLevel"
                          :key="num"
                        ></i>
                      </span>
                      <span
                        v-if="
                          poin.highOrLow === 2 &&
                            (poin.monitStatus === 3 || poin.monitStatus === 2)
                        "
                      >
                        <i
                          class="e6-icon-arrow_down"
                          v-for="num of poin.alarmLevel"
                          :key="num"
                        ></i>
                      </span>
                    </li>
                  </ul>
                </div>
                <div v-if="item.status === 'static'" class="empty-monit">
                  <img :src="monitIcon" alt="" />
                </div>
                <loading-video
                  v-else-if="item.status === 'loading'"
                ></loading-video>
                <div v-else-if="item.status === 'loadError'" class="load-error">
                  <i class="e6-icon-prohibit_line"></i>
                  <p>获取不到视频</p>
                  <a href="javascript:void(0)" @click="reGetVideo(item, index)">
                    重新加载
                  </a>
                </div>
                <div v-else class="real-video-wrap">
                  <e6-video
                    :ref="'video' + index"
                    :muted="false"
                    :url="item.url"
                    @error="videoError(index)"
                    hasAudio
                  ></e6-video>
                </div>
              </div>
            </li>
            <li v-else :key="item.cameraId" :class="videoCls">
              <div class="empty-monit">
                <img :src="monitIcon" alt="" />
              </div>
            </li>
          </template>
        </ul>
      </template>
      <template v-else>
        <div class="video-nodata">
          <img
            src="../../../assets/images/pg-nodata-dark.png"
            alt="请选择需要监控的场景"
          />
          <p>请选择需要监控的场景</p>
        </div>
      </template>
      <div
        class="chat-tip"
        v-if="isFullscreen"
        @click="escFullscreen"
        title="退出全屏"
      >
        <i class="e6-icon-screen-half_line"></i>
      </div>
      <div class="chat-tip" @click="fullscreen" title="全屏" v-else>
        <i class="e6-icon-screen-full_line"></i>
      </div>
    </section>
    <section class="right-part" v-show="!isFullscreen">
      <div
        class="vehicles-wrap"
        v-loading="vehicleLoading"
        element-loading-text="数据正在加载中..."
      >
        <el-tabs
          type="border-card"
          v-model="activeName"
          @tab-click="handleClick"
        >
          <el-tab-pane label="全部" name="-1"></el-tab-pane>
          <el-tab-pane label="在线" name="1"></el-tab-pane>
          <el-tab-pane label="掉线" name="0"></el-tab-pane>
        </el-tabs>
        <div class="operates" ref="routeOperate">
          <div class="vehicle-search-wrap">
            <el-input
              placeholder="中心仓名称"
              v-model="vehicleNo"
              clearable
              @keyup.enter.native="searchVehicle"
            >
              <el-button
                slot="append"
                icon="e6-icon-search_line"
                @click="searchVehicle"
              ></el-button>
            </el-input>
          </div>
        </div>
        <div
          class="vehicles"
          :style="{
            height: treeHeight
          }"
        >
          <e6-tree
            :list="treeData"
            :beforeChange="beforeChangeNode"
            :chkfunc="getSingleData"
            :issingleleaf="true"
            :isOpen="true"
            :is-check="true"
            selectAndCheck
            :clickAndCheckCall="false"
            ref="vehicleTree"
            :disabledNoCheck="false"
          >
            <template #right="node">
              <span v-if="!node.disabled">
                <i
                  :class="[
                    'e6-icon-card_fill',
                    {
                      online: node.onlineStatus === 1
                    }
                  ]"
                ></i>
                <span>{{ node.info }}</span>
              </span>
            </template>
          </e6-tree>
        </div>
        <div class="waregouse-btn">
          <el-button
            type="primary"
            :loading="statusLoading"
            @click.native="startMonit"
          >
            {{ hasVideo ? "停止监控" : "实时监控" }}
          </el-button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import e6Tree from "e6-tree";
import monitIcon from "@/assets/images/video/monit-icon.png";
import loadingVideo from "@/components/video/loadingVideo";
import api from "@/api/monitorCenter/warehouseVideo.js";
export default {
  name: "warehouseRealTimeVideo",
  components: {
    loadingVideo,
    e6Tree
  },
  data() {
    return {
      isShow: true,
      timer: null,
      monitIcon,
      monitStatus: {
        "0": "",
        "1": "正常",
        "2": "预警",
        "3": "报警",
        "4": "掉线",
        "5": "脱温"
      },
      monitStatusClass: {
        "0": "",
        "1": "success",
        "2": "warn",
        "3": "error",
        "4": "off",
        "5": "deheat"
      },
      formatVideo: [], //视频数组
      checkRoutes: [], //已选设备
      activeName: "-1",
      routes: [], //通道池（可能会根据已选车辆改变而改变）
      // 仓库摄像头树
      treeData: [],
      // 仓库摄像头树的高度
      treeHeight: "calc(100% - 146px)",
      vehicleLoading: false, //视频块状态，true时为loading状态
      vehicleNo: "", //树搜索
      statusLoading: false,
      //当摄像头个数≤6时，传1; 表示：当前摄像头只需要唯一状态。
      //当摄像头个数＞6时，第一次请求传1，每30秒刷新一次时，依次传2,3,4,5...后台会根据传入数字返回当前页的监测点信息列表
      pageIndex: 1,
      // 已选树节点
      checkedNode: {},
      formatVideoL: 0, // 格式化的视频块数量 （1，2，4，6，9，12）
      // 是否全屏
      isFullscreen: false,
      // 是否已有视频
      hasVideo: false,
      queryId: []
    };
  },
  computed: {
    videoCls() {
      return "li-" + this.formatVideoL;
    }
  },
  created() {
    this.getCameraTree();
  },
  destroyed() {
    clearTimeout(this.timer);
    this.timer = null;
  },
  mounted() {
    this.$nextTick(async () => {
      // window.addEventListener("beforeunload", () => {
      //   console.log("刷新");
      //   this.closeVideo();
      // });
      //监听全屏
      document.addEventListener(
        "fullscreenchange",
        () => {
          if (document.fullscreenElement) {
            // this.$store.dispatch("common/setFullScreenAct", true);
            this.isFullscreen = true;
          } else {
            // this.$store.dispatch("common/setFullScreenAct", false);
            this.isFullscreen = false;
          }
        },
        false
      );
      document.addEventListener(
        "msfullscreenchange",
        () => {
          if (document.msFullscreenElement) {
            // this.$store.dispatch("common/setFullScreenAct", true);
            this.isFullscreen = true;
          } else {
            // this.$store.dispatch("common/setFullScreenAct", false);
            this.isFullscreen = false;
          }
        },
        false
      );
      document.addEventListener(
        "mozfullscreenchange",
        () => {
          if (document.mozFullScreen) {
            // this.$store.dispatch("common/setFullScreenAct", true);
            this.isFullscreen = true;
          } else {
            // this.$store.dispatch("common/setFullScreenAct", false);
            this.isFullscreen = false;
          }
        },
        false
      );
      document.addEventListener(
        "webkitfullscreenchange",
        () => {
          if (document.webkitIsFullScreen) {
            // this.$store.dispatch("common/setFullScreenAct", true);
            this.isFullscreen = true;
          } else {
            // this.$store.dispatch("common/setFullScreenAct", false);
            this.isFullscreen = false;
          }
        },
        false
      );
      if (this.$route.query.id) {
        this.queryId = Array.isArray(this.$route.query.id)
          ? this.$route.query.id
          : [this.$route.query.id];
        this.statusLoading = true;
        this.vehicleLoading = true;
        this.checkedNode = [];
        await this.openRealTimeVideo();
        // await this.getPointMonit();
        this.statusLoading = false;
        this.vehicleLoading = false;
        setTimeout(() => {
          this.queryId.forEach(e => {
            const nodes = this.$refs.vehicleTree.queryTreeNodeByID(e);
            nodes.forEach(value => {
              this.$refs.vehicleTree.setNodeCheck(value);
            });
          });
        }, 1000);
      }
    });
  },
  methods: {
    beforeLeave() {
      if (this.formatVideo.length === 0) {
        return true;
      } else {
        return false;
      }
    },
    // 视频异常
    videoError(index) {
      this.$set(this.formatVideo[index], "status", "loadError");
    },
    // 轮训(监测点数据的轮训)
    intervalHandler() {
      this.timer = setTimeout(() => {
        if (this.formatVideo.length > 0) {
          if (this.formatVideo.length <= 6) {
            // if (this.formatVideo.length <= 1) {
            this.pageIndex++;
          } else {
            this.pageIndex = 0;
          }
          this.getPointMonit();
          this.intervalHandler();
        }
      }, 1000 * 30);
    },
    // 关闭视频
    closeRealTimeVideo(ids) {
      api
        .closeRealTimeVideo({
          cameraIdList:
            ids || this.formatVideo.map(e => e.cameraId).filter(e => e)
        })
        .then(res => {
          if (res && res.code === 1 && res.result) {
            console.log(res.code);
          }
        });
    },
    // 获取每个摄像头的绑定监测点信息
    getPointMonit() {
      api
        .getPointMonit({
          cameraIdList: this.formatVideo.map(e => e.cameraId).filter(e => e),
          pageIndex: this.pageIndex
        })
        .then(res => {
          if (res && res.code === 1 && res.result) {
            this.checkRoutes = res.result;
            this.formatVideo.forEach((e, index) => {
              const point = this.checkRoutes.find(a => {
                return a.cameraId === e.cameraId;
              });
              // e.pointList = point ? point.pointList : [];
              this.$set(
                this.formatVideo[index],
                "pointList",
                point ? point.pointList : []
              );
              this.$set(
                this.formatVideo[index],
                "monitStatus",
                point.monitStatus
              );
              // return {
              //   ...e,
              //   pointList
              // };
            });
            console.log(this.formatVideo);
            // this.treeData = res.result;
          }
        });
    },
    //点击实时监控按钮-开始播放视频
    async openRealTimeVideo(checkedNode = this.checkedNode) {
      const cameraIdList = checkedNode.reduce((previousValue, currentValue) => {
        if (currentValue.onlineStatus === 1) {
          return [...previousValue, Number(currentValue.id.split("_")[1])];
        } else {
          return previousValue;
        }
      }, []);
      await api
        .openRealTimeVideo({
          cameraIdList: cameraIdList.length ? cameraIdList : this.queryId
        })
        .then(res => {
          if (res && res.code === 1 && res.result) {
            this.formatVideo = res.result.map(e => {
              return {
                cameraId: e.cameraId,
                cameraName: e.cameraName,
                realVideo: true,
                status: e.url ? "loaded" : "loadError",
                url: {
                  flv: e.url
                }
              };
            });
            this.hasVideo = !!this.formatVideo.length;
            // 格式化数量
            this.formatVideoL = this.formatLen(this.formatVideo.length);
            // 格式化视频dom块（增加伪块）
            for (let i = 0; i < this.formatVideoL; i++) {
              // 重新添加空项目
              if (this.formatVideo.length <= i) {
                this.formatVideo.push({
                  status: "static",
                  url: "",
                  videoQuality: "1",
                  realVideo: false
                });
              }
            }
            // this.treeData = res.result;
          }
        })
        .catch(err => {
          this.formatVideo.forEach(value => {
            value.status = "loadError";
          });
          console.log(err);
        });
    },
    formatLen(len) {
      // this.pageIndex = len <= 1 ? 1 : 0;
      // 临时修改
      this.pageIndex = len <= 6 ? 1 : 0;
      if (len > 2) {
        if (len < 5) {
          return 4;
        }
        if (len < 7) {
          return 6;
        } else if (len < 10) {
          return 9;
        } else if (len < 13) {
          return 12;
        } else {
          return 16;
        }
      } else {
        return len;
      }
    },
    // 获取摄像头的最新在线状态 "cameraIdList": [345,6545] //勾选的摄像头ID列表。没选时传[]
    async getCameraLatestStatus(ids = []) {
      try {
        ids = ids.map(v => {
          return Number(v.split("_")[1]);
        });
        const res = await api.getCameraLatestStatus({
          cameraIdList: ids
        });
        if (res && res.code === 1 && res.result) {
          this.checkedNode.forEach(value => {
            const data = res.result.find(
              e => e.cameraId == value.id.split("_")[1]
            );
            value.onlineStatus = data && data.onlineStatus;
          });
          if (res.result.every(e => e.onlineStatus === 0)) {
            return this.$message.error("查询摄像头不在线，无法查询视频");
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    // 获取部门-仓库-摄像头树形结构选择  isSelOutTemp=1（只看脱温）
    getCameraTree() {
      this.vehicleLoading = true;
      api
        .getCameraTree({ onlineStatus: this.activeName })
        .then(res => {
          if (res && res.code === 1 && res.result) {
            this.treeData = res.result;
            this.vehicleLoading = false;
          }
        })
        .catch(() => {
          this.vehicleLoading = false;
        });
    },
    // 全屏
    fullscreen() {
      var element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      }
      // this.$store.dispatch("common/setFullScreenAct", true);
      this.isFullscreen = true;
    },
    // 退出全屏
    escFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
      // this.$store.dispatch("common/setFullScreenAct", false);
      this.isFullscreen = false;
    },
    // 类型切换
    handleClick() {
      this.getCameraTree();
      this.selectVehicle = "";
    },
    // 树搜索
    searchVehicle() {
      this.$refs.vehicleTree.queryTreeNodeByName(this.vehicleNo);
    },
    // 开始监控
    async startMonit() {
      if (!this.hasVideo) {
        // 获取树选中的选项
        this.checkedNode = this.$refs.vehicleTree.getAllNodes().data;
        if (this.checkedNode.length > 16) {
          return this.$message.warning("最多支持16个摄像头");
        }
        if (this.checkedNode.length === 0) {
          return this.$message.warning("请选择摄像头");
        }
        try {
          this.statusLoading = true;
          this.vehicleLoading = true;
          await this.getCameraLatestStatus(this.checkedNode.map(e => e.id));
          !this.checkedNode.every(e => e.onlineStatus === 0) &&
            (await this.openRealTimeVideo());
          // this.formatVideo.length > 0 && (await this.getPointMonit()); // 监测点的信息展示
          // await this.intervalHandler(); //  轮训监测点
          this.statusLoading = false;
          this.vehicleLoading = false;
        } catch (error) {
          this.statusLoading = false;
          this.vehicleLoading = false;
          console.log(error);
        }
      } else {
        this.closeRealTimeVideo();
        clearTimeout(this.timer);
        this.timer = null;
        this.formatVideo = [];
        this.$refs.vehicleTree.setAllNodeCheck(false);
        this.statusLoading = false;
        this.vehicleLoading = false;
        this.hasVideo = false;
        this.pageIndex = 1;
      }
    },
    //选择树前的回调
    async beforeChangeNode(...arg) {
      let { node, next } = arg[0];
      if (node.disabled) return; //节点是否可选
      // if (this.checkedNode.id === node.id) return; // 点击相同节点无效
      // let tip, action; // 提示语和相关动作
      if (this.hasVideo) {
        //在监控，并且在对讲
        // tip = "切换摄像头将关闭视频，确定是否切换？";
        // action = async () => {
        next();
        if (
          this.formatVideo.some(
            e => e.cameraId === Number(node.id.split("_")[1])
          )
        ) {
          this.closeRealTimeVideo([Number(node.id.split("_")[1])]);
          // this.$refs.vehicleTree.setNodeCheck(node, false);
          clearTimeout(this.timer);
          this.timer = null;
          let index = this.formatVideo.findIndex(
            e => e.cameraId === Number(node.id.split("_")[1])
          );
          this.$delete(this.formatVideo, index);
          if (this.formatVideo.length > 0) {
            // 临时修改
            if (this.formatVideo.length <= 6) {
              this.pageIndex = 1;
            } else {
              this.pageIndex = 0;
            }
            // this.getPointMonit();
            // this.intervalHandler();
          } else if (this.formatVideo.length === 0) {
            this.hasVideo = false;
          }
        } else {
          this.statusLoading = true;
          this.vehicleLoading = true;
          clearTimeout(this.timer);
          this.timer = null;
          console.log(this.$refs.vehicleTree.getAllNodes());
          this.checkedNode = this.$refs.vehicleTree.getAllNodes().data;
          if (this.checkedNode.length > 16) {
            return this.$message.warning("最多支持16个摄像头");
          }
          try {
            await this.closeRealTimeVideo();
            await this.getCameraLatestStatus(this.checkedNode.map(e => e.id));
            await this.openRealTimeVideo();
            // this.formatVideo.length > 0 && (await this.getPointMonit());
            await this.intervalHandler();
            this.statusLoading = false;
            this.vehicleLoading = false;
          } catch (error) {
            this.statusLoading = false;
            this.vehicleLoading = false;
            console.log(error);
          }
          // }
          // this.closeAllVideo(this.checkedNode.label);
          // this.clearShutdownClock();
        }
      } else {
        next();
        return;
      }
    },
    clearShutdownClock() {
      clearTimeout(this.shutdownClock);
      this.shutdownClock = null;
    },
    generateAskDialog(tip, action) {
      this.$confirm(tip, {
        closeOnClickModal: false,
        closeOnPressEscape: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      })
        .then(() => {
          action();
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 树选中
    getSingleData(node) {
      this.checkedNode = node;
      this.$set(this.checkedNode, "info", "(正在获取流量中...)");
      // 将视频dom都重置到初始态
      // this.formatVideo = [];
      // console.log(node);
    },
    async reGetVideo(obj, index) {
      this.$set(this.formatVideo[index], "status", "loading");
      try {
        const res = await api.getCameraLatestStatus({
          cameraIdList: [obj.cameraId]
        });
        if (res && res.code === 1 && res.result) {
          this.checkedNode.forEach(value => {
            const data = res.result.find(
              e => e.cameraId === Number(value.id.split("_")[1])
            );
            value.onlineStatus = data && data.onlineStatus;
          });
          if (res.result.every(e => e.onlineStatus === 0)) {
            this.$delete(this.formatVideo, index);
            if (this.formatVideo.length === 0) {
              clearTimeout(this.timer);
              this.timer = null;
              this.statusLoading = false;
              this.vehicleLoading = false;
              this.hasVideo = false;
              this.pageIndex = 1;
            }
            return this.$message.error("查询摄像头不在线，无法查询视频");
          } else {
            await api
              .openRealTimeVideo({
                cameraIdList: [obj.cameraId]
              })
              .then(res => {
                if (
                  res &&
                  res.code === 1 &&
                  Array.isArray(res.result) &&
                  res.result.length > 0
                ) {
                  this.$set(this.formatVideo, index, {
                    cameraId: res.result[0].cameraId,
                    cameraName: res.result[0].cameraName,
                    realVideo: true,
                    status: res.result[0].url ? "loaded" : "loadError",
                    url: {
                      flv: res.result[0].url
                    }
                  });
                }
              })
              .catch(err => {
                this.$set(this.formatVideo[index], "status", "loadError");
                console.log(err);
              });
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    closeVideo() {
      this.closeRealTimeVideo();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/videoCommon.scss";
@import "@/assets/styles/videoMonit.scss";
.video-quality-selector {
  background: transparent;
  .el-select-dropdown__wrap {
    .el-select-dropdown__list {
      padding: 0px;
      .el-select-dropdown__item {
        padding: 0 12px;
        height: 26px;
        line-height: 26px;
        font-weight: normal;
        background: transparent;
        color: #fff;
        &:hover {
          background: #32b8e8;
        }
      }
    }
  }
  .popper__arrow {
    top: -7px;
  }
}
/deep/.el-tabs__nav-wrap::after {
  height: 0;
}
.video-live .right-part .title-wrap {
  width: 100%;
  padding: 0;
}
.el-tabs--border-card {
  border: 0;
}
/deep/.el-tabs__nav.is-top {
  display: flex;
  width: 100%;
  .el-tabs__item {
    height: 36px;
    line-height: 36px;
    margin: 0;
    font-weight: normal;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-tabs__item.is-active {
    margin: 0;
    position: relative;
  }
  .el-tabs__item.is-active::after {
    content: "";
    display: inline-block;
    height: 3px;
    width: 100%;
    position: absolute;
    top: -1px;
    left: 0;
    background-color: #46bfea;
  }
}
/deep/.el-tabs--border-card > .el-tabs__content {
  display: none;
}
.el-tabs--top /deep/.el-tabs__item {
  width: 50%;
  text-align: center;
}
.waregouse-btn {
  display: flex;
  justify-content: center;
  height: 40ox;
  align-items: center;
  padding: 10px 0;
}
.video-dom-wrap > li {
  position: relative;
}
.video-live .right-part .vehicles-wrap {
  height: 100%;
}
.video-live .videos-wrap .video-dom-wrap .real-message {
  width: 180px;
  height: 166px;
  background: rgba($color: #000000, $alpha: 0.5);
  border-radius: 5px;
  position: absolute;
  bottom: 60px;
  left: 10px;
  padding: 10px;
  box-sizing: border-box;
  z-index: 9;
  .scrollbar {
    height: 100%;
  }
  li {
    color: #fff;
    font-size: 12px;
    margin: 0;
    height: calc(100% / 6);
    display: flex;
    align-items: center;
  }
  .success {
    color: #67c23a;
  }
  .warn {
    color: #e39726;
  }
  .error {
    color: #f45a5a;
  }
  // 掉线
  .off {
    color: #ffffff;
  }
  // 脱温
  .deheat {
    color: #ea6fc3;
  }
}
.route-info {
  p#success {
    background: rgba($color: #67c23a, $alpha: 0.7);
  }
  p#warn {
    background: rgba($color: #e39726, $alpha: 0.7);
  }
  p#error {
    background: rgba($color: #f45a5a, $alpha: 0.7);
  }
  // 掉线
  p#off {
    background: rgba(70, 191, 234, 0.7);
  }
  // 脱温
  p#deheat {
    background: rgba($color: #ea6fc3, $alpha: 0.7);
  }
}
.vehicles {
  padding: 0 10px;
}
.rotate-90-transition {
  transition: transform 0.5s;
}
.rotate-90 {
  transform: rotateX(90deg);
}
.video-nodata {
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  & > img {
    display: block;
    margin: 0 auto;
  }
  & > p {
    font-size: 14px;
    line-height: 14px;
    color: #256ab1;
    text-align: center;
    margin: 10px 0;
  }
}
</style>
